// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i3-0";
export var actionModalContentContainer = "_i3-1";
export var createTagButton = "_i3-2";
export var footerContainer = "_i3-7";
export var fullWidthDivider = "_i3-3";
export var hasCreateTagButton = "_i3-4";
export var noCreateTagButton = "_i3-5";
export var tagsContainer = "_i3-6";
export var tagsModalContentContainer = "_i3-8";